import { create } from 'zustand';

interface Sumiting {
  isSubmitting: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
}

export const useSubmitting = create<Sumiting>((set) => ({
  isSubmitting: false,
  setIsSubmitting: (isSubmitting: boolean) => set({ isSubmitting }),
}));
